import { escapeAttr, escapeHtml, linkAttrs } from "@emkit/builder-core";
export const CAROUSEL_DEFAULTS = {
    slides: [
        {
            id: "cs1",
            imageUrl: "https://placehold.co/1600x900/111827/ffffff?text=Slide+1",
            alt: "Slide 1",
            title: "Clean static HTML",
            caption: "Pages compile to zero-runtime HTML.",
        },
        {
            id: "cs2",
            imageUrl: "https://placehold.co/1600x900/1e293b/ffffff?text=Slide+2",
            alt: "Slide 2",
            title: "Visual editor",
            caption: "Drag, drop, inspect. Ship.",
        },
        {
            id: "cs3",
            imageUrl: "https://placehold.co/1600x900/0f172a/ffffff?text=Slide+3",
            alt: "Slide 3",
            title: "Responsive by default",
            caption: "Breakpoint switcher for every widget.",
        },
    ],
    aspectRatio: "16/9",
    showDots: true,
    showArrows: true,
    radius: 12,
    overlayColor: "rgba(0,0,0,0.35)",
    textColor: "#ffffff",
    accent: "#ffffff",
};
export const carouselWidget = {
    type: "carousel",
    defaultProps: CAROUSEL_DEFAULTS,
    renderHtml(props, ctx) {
        const slides = props.slides ?? [];
        if (slides.length === 0) {
            return `<div class="emk-carousel" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty carousel — add slides in the inspector)</div>`;
        }
        const aspect = props.aspectRatio ?? "16/9";
        const showDots = props.showDots ?? true;
        const showArrows = props.showArrows ?? true;
        const radius = props.radius ?? 12;
        const overlay = props.overlayColor ?? "rgba(0,0,0,0.35)";
        const text = props.textColor ?? "#ffffff";
        const accent = props.accent ?? "#ffffff";
        const gid = `car-${Math.random().toString(36).slice(2, 8)}`;
        const inputs = slides
            .map((_, i) => `<input type="radio" name="${escapeAttr(gid)}" id="${escapeAttr(gid)}-${i}"${i === 0 ? " checked" : ""} style="position:absolute;opacity:0;pointer-events:none" aria-hidden="true">`)
            .join("");
        const panels = slides
            .map((s, i) => {
            const url = s.imageUrl ? (ctx.resolveAssetUrl?.(s.imageUrl) ?? s.imageUrl) : "";
            const img = url
                ? `<img src="${escapeAttr(url)}" alt="${escapeAttr(s.alt ?? "")}" loading="${i === 0 ? "eager" : "lazy"}" decoding="async" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">`
                : "";
            const overlayEl = s.title || s.caption
                ? `<div style="position:absolute;inset:0;background:linear-gradient(to top,${overlay},transparent 60%);display:flex;flex-direction:column;justify-content:flex-end;padding:24px;color:${text}">${s.title ? `<h3 style="margin:0;font-size:24px;font-weight:700;line-height:1.2">${escapeHtml(s.title)}</h3>` : ""}${s.caption ? `<p style="margin:6px 0 0;font-size:15px;line-height:1.5;opacity:0.9">${escapeHtml(s.caption)}</p>` : ""}</div>`
                : "";
            const body = `<div class="emk-car-panel" data-idx="${i}" style="position:absolute;inset:0;display:none">${img}${overlayEl}</div>`;
            return s.href
                ? `<a href="${escapeAttr(s.href)}"${linkAttrs(s.href)} style="display:contents">${body}</a>`
                : body;
        })
            .join("");
        const dots = showDots
            ? slides
                .map((_, i) => `<label for="${escapeAttr(gid)}-${i}" class="emk-car-dot" data-idx="${i}" style="width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.5);cursor:pointer;transition:transform 0.15s,background 0.15s" aria-label="Go to slide ${i + 1}"></label>`)
                .join("")
            : "";
        const arrows = showArrows
            ? slides
                .map((_, i) => {
                const prev = (i - 1 + slides.length) % slides.length;
                const next = (i + 1) % slides.length;
                return `<div class="emk-car-arrows" data-active="${i}" style="position:absolute;inset:0;pointer-events:none;display:none"><label for="${escapeAttr(gid)}-${prev}" class="emk-car-arrow" aria-label="Previous slide" style="pointer-events:auto;position:absolute;left:12px;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:50%;background:rgba(0,0,0,0.4);color:#fff;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px">‹</label><label for="${escapeAttr(gid)}-${next}" class="emk-car-arrow" aria-label="Next slide" style="pointer-events:auto;position:absolute;right:12px;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:50%;background:rgba(0,0,0,0.4);color:#fff;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px">›</label></div>`;
            })
                .join("")
            : "";
        // Scoped style rules: selected radio reveals its panel + arrow set + highlights its dot.
        const rules = slides
            .map((_, i) => {
            const sel = `#${gid}-${i}:checked`;
            let rule = `.${gid} ${sel}~.emk-car-viewport .emk-car-panel[data-idx="${i}"]{display:block}`;
            if (showDots) {
                rule += `.${gid} ${sel}~.emk-car-nav .emk-car-dot[data-idx="${i}"]{background:${accent};transform:scale(1.3)}`;
            }
            if (showArrows) {
                rule += `.${gid} ${sel}~.emk-car-viewport .emk-car-arrows[data-active="${i}"]{display:block}`;
            }
            return rule;
        })
            .join("");
        const nav = showDots
            ? `<div class="emk-car-nav" style="position:absolute;bottom:12px;left:50%;transform:translateX(-50%);display:flex;gap:8px;z-index:2">${dots}</div>`
            : "";
        return `<div class="emk-carousel ${gid}" style="position:relative;width:100%;aspect-ratio:${aspect};border-radius:${radius}px;overflow:hidden;font-family:inherit"><style>${rules}</style>${inputs}<div class="emk-car-viewport" style="position:absolute;inset:0">${panels}${arrows}</div>${nav}</div>`;
    },
};
//# sourceMappingURL=carousel.js.map